import {createReducer, on} from '@ngrx/store';
import {ProduktDialogState} from '../states/produkt-dialog.state';
import {ProduktDialogActions} from '../actions/produkt-dialog.actions';
import {BerechnungsregelMengeMalEinzelpreisDTO} from '../../openapi/fakturierung-openapi';


export const initialProduktDialogState: ProduktDialogState = {
  isOpen: false,
  produkt: {},
  mengeneinheiten: [],
  mengeneinheitenFilter: '',
  addToBeleg: undefined,
};

export const produktDialogReducer = createReducer(
  initialProduktDialogState,


  on(
    ProduktDialogActions.open,
    (state, action) => ({
      ...state,
      isOpen: true,
      produkt: action.produkt || {},
      addToBeleg: action.addToBeleg ?? undefined,
    })
  ),

  on(
    ProduktDialogActions.setMengeneinheiten,
    (state, {mengeneinheiten}) => {
      return {
        ...state,
        mengeneinheiten: mengeneinheiten,
      };
    }
  ),

  on(
    ProduktDialogActions.changeProdukt,
    (state, {produkt}) => {
      return {
        ...state,
        produkt,
      };
    },
  ),

  on(
    ProduktDialogActions.close,
    () => ({
      ...initialProduktDialogState,
    })
  ),

  on(
    ProduktDialogActions.assignNextProduktnummer,
    (state, {nummer}) => {
      return {
        ...state,
        produkt: {
          ...state.produkt,
          produktnummer: state.produkt.nummer === undefined ? nummer : state.produkt.nummer,
        },
      };
    },
  ),

  on(
    ProduktDialogActions.changeEinheitenAutocomplete,
    (state, {filter}) => {
      const updatedBerechnungsregel = {...state.produkt.berechnungsregel};
      const berechnungsregelTyp = state.produkt.berechnungsregel?.typ;
      switch (berechnungsregelTyp) {
        case 'BerechnungsregelMengeMalEinzelpreis':
          (updatedBerechnungsregel as BerechnungsregelMengeMalEinzelpreisDTO).mengeneinheitNummer = 0;
          break;
        case 'BerechnungsregelFestbetrag':
          break;
        case 'BerechnungsregelKeine':
          break;
        default:
          new Error('Unknown Berechnungsregel: ' + berechnungsregelTyp);
      }

      return {
        ...state,
        produkt: {
          ...state.produkt,
          berechnungsregel: updatedBerechnungsregel,
        },
        mengeneinheitenFilter: filter,
      };
    }
  )
);
